module.exports = __webpack_public_path__ + "static/media/bowl-01.7f13d6c7.svg";